import React from 'react';
import { Box, Typography } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import CheckBoxSec from './CheckBoxSec';


const LegendItem = ({ label, bgColor }) => (
    <Box display="flex" alignItems="center" mr={3}>
        <Box
            sx={{
                width: 20,
                height: 20,
                borderRadius: '4px',
                backgroundColor: bgColor,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                mr: 1,
            }}
        >
            <CheckIcon sx={{ color: '#fff', fontSize: 16 }} />
        </Box>
        <Typography sx={{ fontSize: 14 }}>{label}</Typography>
    </Box>
);

const PermissionLegend = () => {
    return (
        <Box
            sx={{
                border: '1px solid #0076FE',
                borderRadius: '8px',
                padding: '16px 24px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                backgroundColor: '#0076FE05',
                    height: '58px',
                    margin:'16px auto 0'
            }}
        >
            <Typography sx={{ fontWeight: '700', color: '#1976d2', mr: 3, fontSize: '16px', fontFamily: 'Manrope' }}>
                LEGEND
            </Typography>
            <Box display="flex" alignItems="center" sx={{ gap: 5 }}>
                <CheckBoxSec projects={[{ name: 'ON' }]} />
                <CheckBoxSec projects={[{ name: 'Default Settings' }]} />
                <CheckBoxSec projects={[{ name: 'OFF' }]} />
                <CheckBoxSec projects={[{ name: 'Not available' }]} />
            </Box>
        </Box>
    );
};

export default PermissionLegend;
